import { render, staticRenderFns } from "./ActividadDespacio.vue?vue&type=template&id=cd8d3db6&"
import script from "./ActividadDespacio.vue?vue&type=script&lang=ts&"
export * from "./ActividadDespacio.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadDespacio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('cd8d3db6', component.options)
    } else {
      api.reload('cd8d3db6', component.options)
    }
    module.hot.accept("./ActividadDespacio.vue?vue&type=template&id=cd8d3db6&", function () {
      api.rerender('cd8d3db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasCrm/ActividadDespacio.vue"
export default component.exports